import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { getBackendUrl, LoadStateInfo, loaded, loading, notStarted, error, getImagesUrl, failedResponse, INVALID_ID } from "../common";
import { getToken } from "../../features/user/UserAvatar";
import { RoutineItemInfo } from "./routineItemSlice";

export interface RoutineItemInsUptState {
  state: LoadStateInfo;
  routineItem: RoutineItemInfo;
}

const initialState: RoutineItemInsUptState = {
  state: notStarted(),
  routineItem: emptyRoutineItem(),
};

export function emptyRoutineItem(): RoutineItemInfo {
  return {
    id: INVALID_ID,
    routineId: "",
    name: "",
    url: `${getImagesUrl()}/default/routine.webp`,
  };
}

export interface RoutineItemInsertRequest {
  routineItem: RoutineItemInfo;
}
export const routineItemInsert = createAsyncThunk(
  "routineItemInsert",
  async (param: RoutineItemInsertRequest, thunkAPI) => {
    console.debug("insert routine item");
    const response = await fetch(`${getBackendUrl()}/api/routine-item`, {
      method: "POST",
      signal: thunkAPI.signal,
      headers: {
        "Authorization": `Bearer ${getToken()}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(param.routineItem)
    });
    if(response.ok) {
      return await response.json();
    } else {
      return thunkAPI.rejectWithValue(failedResponse( response ));
    }
  }
);

export interface RoutineItemUpdateRequest {
  routineItemId: string;
  routineItem: RoutineItemInfo;
}
export const routineItemUpdate = createAsyncThunk(
  "routineItemUpdate",
  async (param: RoutineItemUpdateRequest, thunkAPI) => {
    console.debug("update routine");
    const response = await fetch(`${getBackendUrl()}/api/routine-item/${param.routineItemId}`, {
      method: "PUT",
      signal: thunkAPI.signal,
      headers: {
        "Authorization": `Bearer ${getToken()}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(param.routineItem)
    });
    if(response.ok) {
      return await response.json();
    } else {
      return thunkAPI.rejectWithValue(failedResponse( response ));
    }
  }
);

export interface RoutineItemRemoveRequest {
  routineItem: RoutineItemInfo;
}
export const routineItemRemove = createAsyncThunk(
  "routineItemDelete",
  async (param: RoutineItemRemoveRequest, thunkAPI) => {
    console.debug("delete routine");
    const response = await fetch(`${getBackendUrl()}/api/routine-item/${param.routineItem.id}`, {
      method: "DELETE",
      signal: thunkAPI.signal,
      headers: {
        "Authorization": `Bearer ${getToken()}`,
      },
    });
    if(response.ok) {
      return "OK";
    } else {
      return thunkAPI.rejectWithValue(failedResponse( response ));
    }
  }
);


export const routineItemInsUpdSlice = createSlice({
  name: "routineItemInsUpd",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    set: (state, action: PayloadAction<RoutineItemInfo>) => {
      state.state = notStarted();
      state.routineItem = action.payload;
    },
    clean: (state) => {
      state.state = notStarted();
      state.routineItem = emptyRoutineItem();
    }
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(routineItemInsert.pending, (state, /* action */) => {
        state.state = loading();
      })
      .addCase(routineItemInsert.fulfilled, (state, action) => {
        console.debug(`${action.type}`);
        state.state = loaded();
        state.routineItem = action.payload;
      })
      .addCase(routineItemInsert.rejected, (state, action) => {
        state.state = error(action);
      })

      .addCase(routineItemUpdate.pending, (state, /* action */) => {
        state.state =  loading();
      })
      .addCase(routineItemUpdate.fulfilled, (state, action) => {
        console.debug(`${action.type}`);
        state.state =  loaded();
        state.routineItem = action.payload;
      })
      .addCase(routineItemUpdate.rejected, (state, action) => {
        state.state = error(action);
      })

      .addCase(routineItemRemove.pending, (state, /* action */) => {
        state.state =  loading();
      })
      .addCase(routineItemRemove.fulfilled, (state, action) => {
        console.debug(`${action.type}`);
        state.state =  loaded();
      })
      .addCase(routineItemRemove.rejected, (state, action) => {
        state.state = error(action);
      });
    },
});

// export const { } = routineItemInsUpdSlice.actions;

export const selectRoutineItemInsUpd = (state: RootState) => state.routineItemInsUpd;

export default routineItemInsUpdSlice.reducer;
